import { useState } from 'react'
import { useModal } from './useModal'

type UseItemDialogReturn<T> = {
  item: T
  isOpen: boolean
  openItemDialog: (newItem: T) => void
  closeItemDialog: () => void
}

export function useItemDialog<T>(
  defaultItem: T,
  updateOnClose: boolean = true,
): UseItemDialogReturn<T> {
  const { isOpen, open, close } = useModal()
  const [item, setItem] = useState<T>(defaultItem)

  const openItemDialog = (newItem: T) => {
    setItem(newItem)
    open()
  }

  const closeItemDialog = () => {
    close()
    if (updateOnClose) {
      setItem(defaultItem)
    }
  }

  return {
    item,
    isOpen,
    openItemDialog,
    closeItemDialog,
  }
}
